module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/white-labelling.json
// module id = 315
// module chunks = 46344362402717